import "./modalLog.css";
import closeModalLog from "../../../assets/svgs/close.svg";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import formatLogToHtml from "../../../utils/formatMarkdownToHtml";

interface MessageComponentProps {
  message: string;
}

const MessageComponent = ({ message }: MessageComponentProps) => {
  const formattedMessage = formatLogToHtml(message);
  return <div dangerouslySetInnerHTML={{ __html: formattedMessage }} />;
};

interface ModalLogProps {
  titleModalLog: string;
  subTitleModalLog: string;
  imgIcon?: string;
  textModalLog: string;
  onClose: () => void;
  className?: string;
}

const ModalLog = ({
  titleModalLog,
  subTitleModalLog,
  textModalLog,
  imgIcon,
  onClose,
  className,
}: ModalLogProps) => {
  return (
    <div className="modalOverlay">
      <div className={className}>
        <div
          style={{
            display: "flex",
            position: "absolute",
            right: 40,
          }}
          >
          <ButtonGeneric
            onClick={onClose}
            img={closeModalLog}
            colorTitle={""}
            style="closeModal"
          />
        </div>
        <div className="headerModal">
          <img
            style={{ width: "33px", height: "33px" }}
            src={imgIcon}
            alt="modal do log aberto"
          />
          <p className="modalTitle">{titleModalLog}</p>
          <div style={{ width: "5%" }}></div>
        </div>

        <div className="rolagemModal">
          <h4 className="modalSubtitle">
            <MessageComponent message={subTitleModalLog} />
          </h4>
          <p className="modalText">
            <MessageComponent message={textModalLog} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default ModalLog;
